module.exports = __webpack_public_path__ + "static/media/survival-graph.aba9dec9.png";